import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';

import {fetchLesson, selectLessons, selectExercises} from '../../redux/slices/builder';

import {READING_EXERCISE_GOAL_MEANING, READING_EXERCISE_GOAL_ASSESSMENT} from '../../constants';

import logoDarkImage from '../images/logo-flamingo-dark.png';
import styles from '../css/PrintableLessonWorksheet.module.css';

function renderReadingForFluency(exercise, index) {
  return (
    <table className={`m-b-20 ${styles['no-break']}`} key={`${exercise._id}-${index}`}>
      <tbody>
        {/* exercise title */}
        <tr>
          <td colSpan="24">
            <h2
              className="fnt-regular clr-dark-blue"
              style={{fontSize: '1.6rem'}}
            >{`Reading for Fluency: ${exercise.name}`}</h2>
          </td>
        </tr>
        {/* description */}
        <tr>
          <td colSpan="24">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Description
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.description}</p>
          </td>
        </tr>
        {/* book details */}
        <tr>
          {/* genre */}
          <td colSpan="6">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Genre
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.genre}</p>
          </td>
          {/* language */}
          <td colSpan="6">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Language
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.language}</p>
          </td>
          {/* EIL */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              EIL
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.levelEIL}</p>
          </td>
          {/* F&P */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              F&amp;P
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.levelFP}</p>
          </td>
          {/* Words */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Words
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.wordCount}</p>
          </td>
        </tr>
        {/* border bottom */}
        <tr className="b-bot-1px" style={{height: '15px'}}></tr>
      </tbody>
    </table>
  );
}

function renderReadingForAssessment(exercise, index) {
  return (
    <table className={`m-b-20 ${styles['no-break']}`} key={`${exercise._id}-${index}`}>
      <tbody>
        {/* exercise title */}
        <tr>
          <td colSpan="24">
            <h2
              className="fnt-regular clr-dark-blue"
              style={{fontSize: '1.6rem'}}
            >{`Targeted Assessment: ${exercise.name}`}</h2>
          </td>
        </tr>
        {/* description */}
        <tr>
          <td colSpan="24">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Description
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.description}</p>
          </td>
        </tr>
        {/* book details */}
        <tr>
          {/* genre */}
          <td colSpan="6">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Genre
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.genre}</p>
          </td>
          {/* language */}
          <td colSpan="6">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Language
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.language}</p>
          </td>
          {/* EIL */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              EIL
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.levelEIL}</p>
          </td>
          {/* F&P */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              F&amp;P
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.levelFP}</p>
          </td>
          {/* Words */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Words
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.wordCount}</p>
          </td>
        </tr>
        {/* running record */}
        <tr>
          <td colSpan="24">
            <h3 className="m-t-10">Running Record</h3>
          </td>
        </tr>
        <tr>
          {/* accuracy */}
          <td colSpan="8" className="b-bot-1px" style={{borderColor: 'black'}}>
            <table style={{marginBottom: '25px'}}>
              <tbody>
                <tr>
                  <td className="text-left">% Accuracy:</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          {/* observations */}
          <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}>
            <table className="m-t-15" style={{marginBottom: '175px'}}>
              <tbody>
                <tr>
                  <td className="text-left">Observations:</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        {/* border bottom */}
        <tr className="b-bot-1px" style={{height: '15px'}}></tr>
      </tbody>
    </table>
  );
}

function rendeReadingForMeaning(exercise, index) {
  return (
    <table className={`m-b-20 ${styles['no-break']}`} key={`${exercise._id}-${index}`}>
      <tbody>
        {/* exercise title */}
        <tr>
          <td colSpan="24">
            <h2
              className="fnt-regular clr-dark-blue"
              style={{fontSize: '1.6rem'}}
            >{`Reading for Meaning: ${exercise.name}`}</h2>
          </td>
        </tr>
        {/* description */}
        <tr>
          <td colSpan="24">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Description
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.description}</p>
          </td>
        </tr>
        {/* book details */}
        <tr>
          {/* genre */}
          <td colSpan="6">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Genre
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.genre}</p>
          </td>
          {/* language */}
          <td colSpan="6">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Language
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.language}</p>
          </td>
          {/* EIL */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              EIL
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.levelEIL}</p>
          </td>
          {/* F&P */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              F&amp;P
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.levelFP}</p>
          </td>
          {/* Words */}
          <td colSpan="4">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Words
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.config.wordCount}</p>
          </td>
        </tr>
        {/* running record */}
        <tr>
          <td colSpan="24">
            <h3 className="m-t-10">Running Record</h3>
          </td>
        </tr>
        <tr>
          {/* Challenging words */}
          <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}>
            <table style={{marginBottom: '25px'}}>
              <tbody>
                <tr>
                  <td className="text-left">Challenging Words:</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          {/* Prompting Strategy and Comprehension Notes: */}
          <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}>
            <table className="m-t-15" style={{marginBottom: '175px'}}>
              <tbody>
                <tr>
                  <td className="text-left">Prompting Strategy and Comprehension Notes::</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        {/* border bottom */}
        <tr className="b-bot-1px" style={{height: '15px'}}></tr>
      </tbody>
    </table>
  );
}

function renderWordWork(exercise, index) {
  return (
    <table className={`m-b-20 ${styles['no-break']}`} key={`${exercise._id}-${index}`}>
      <tbody>
        {/* exercise title */}
        <tr>
          <td colSpan="24">
            <h2 className="fnt-regular clr-dark-blue" style={{fontSize: '1.6rem'}}>{`Word Work: ${exercise.name}`}</h2>
          </td>
        </tr>
        {/* description */}
        <tr>
          <td colSpan="24">
            <p className="fnt-label" style={{fontSize: '0.85rem'}}>
              Description
            </p>
            <p style={{fontSize: '1rem'}}>{exercise.description}</p>
          </td>
        </tr>
        {/* words */}
        <tr>
          {/* decoded */}
          <td colSpan="8">
            <h4 className="fnt-bold">Decoded</h4>
            {/* blanks for words to be handwritten */}
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* gutter */}
          <td colSpan="1"></td>

          {/* decoded */}
          <td colSpan="8">
            <h4 className="fnt-bold">Encoded</h4>
            {/* blanks for words to be handwritten */}
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
            <table className="m-t-30">
              <tbody>
                <tr>
                  <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}></td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        {/* running record */}
        <tr>
          <td colSpan="24">
            <h3 className="m-t-10">Running Record</h3>
          </td>
        </tr>
        <tr>
          {/* accuracy */}
          <td colSpan="8" className="b-bot-1px" style={{borderColor: 'black'}}>
            <table style={{marginBottom: '25px'}}>
              <tbody>
                <tr>
                  <td className="text-left">% Accuracy:</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          {/* observations */}
          <td colSpan="24" className="b-bot-1px" style={{borderColor: 'black'}}>
            <table className="m-t-15" style={{marginBottom: '175px'}}>
              <tbody>
                <tr>
                  <td className="text-left">Observations:</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        {/* border bottom */}
        <tr className="b-bot-1px" style={{height: '15px'}}></tr>
      </tbody>
    </table>
  );
}

function renderWritingForReading(exercise, index) {
  return (
    <table className={`m-b-20 ${styles['no-break']}`} key={`${exercise._id}-${index}`}>
      <tbody>
        {/* exercise title */}
        <tr>
          <td colSpan="24">
            <h2
              className="fnt-regular clr-dark-blue"
              style={{fontSize: '1.6rem'}}
            >{`Writing for Reading: ${exercise.name}`}</h2>
          </td>
        </tr>
        {/* sentence */}
        <tr>
          <td colSpan="24">
            <h4 dangerouslySetInnerHTML={{__html: exercise.config.sentenceHTML}} className={styles['print-color-exact']}></h4>
          </td>
        </tr>
        {/* border bottom */}
        <tr className="b-bot-1px" style={{height: '15px'}}></tr>
      </tbody>
    </table>
  );
}

function renderAssessment(exercise, index) {
  return (
    <table className={`m-b-20 ${styles['no-break']}`} key={`${exercise._id}-${index}`}>
      <tbody>
        {/* exercise title */}
        <tr>
          <td colSpan="24">
            <h2 className="fnt-regular clr-dark-blue" style={{fontSize: '1.6rem'}}>{`Assessment: ${exercise.name}`}</h2>
          </td>
        </tr>
        <tr>
          <td colSpan="24">
            <p style={{fontSize: '1rem'}}>
              Assessment PDFs must be printed out seperately.{' '}
              <a href={exercise.config.url} target="_blank" rel="noreferrer">
                Click here
              </a>{' '}
              to open PDF file.
            </p>
          </td>
        </tr>
        {/* border bottom */}
        <tr className="b-bot-1px" style={{height: '15px'}}></tr>
      </tbody>
    </table>
  );
}

export default function PrintableLessonWorksheet() {
  const dispatch = useDispatch();

  const lessons = useSelector(selectLessons);
  const exercises = useSelector(selectExercises);

  const {lessonID} = useParams();
  const lesson = lessons.find((lesson) => lesson._id === lessonID);
  const steps = lesson?.steps ?? [];
  const config = lesson?.config ?? {};

  useEffect(() => {
    dispatch(fetchLesson(lessonID));
  }, [dispatch, lessonID]);

  useEffect(() => {
    document.body.classList.add(styles['bg-body']);

    return () => {
      document.body.classList.remove(['bg-body']);
    };
  });

  function renderStep(step, stepIndex) {
    return (
      <table className="m-t-15" key={step.name}>
        {/* repeatable step header */}
        <thead>
          <tr>
            <td colSpan="24">
              <h1 className="fnt-medium clr-dark-blue" style={{fontSize: '2rem'}}>
                {step.name}
              </h1>
            </td>
          </tr>
        </thead>

        {/* list of exercises for this step */}
        <tbody>
          <tr>
            <td colSpan="24">
              {step.exercises.map((exerciseID, index) => {
                const exercise = exercises.find((exercise) => exercise._id === exerciseID);
                if (exercise.type === 'READING') {
                  const key = `${stepIndex}-${index}`;
                  const readingGoals = config?.readingExerciseGoals?.[key];;
                  if (readingGoals === READING_EXERCISE_GOAL_MEANING) return rendeReadingForMeaning(exercise, index);
                  else if (readingGoals === READING_EXERCISE_GOAL_ASSESSMENT) return renderReadingForAssessment(exercise, index);
                  return renderReadingForFluency(exercise, index); // Default
                } else if (exercise.type === 'WORD_WORK') return renderWordWork(exercise, index);
                else if (exercise.type === 'ASSESSMENT') return renderAssessment(exercise, index);
                else if (exercise.type === 'WRITING') return renderWritingForReading(exercise, index);
                return null;
              })}
            </td>
          </tr>
        </tbody>
        {/* end: list of exercises for this step */}
      </table>
    );
  }

  return (
    <div className={styles.letter}>
      {/* Each sheet element should have the class "sheet" */}
      {/* "padding in inches" is optional: you can set .125, .25, .375, 1 */}
      <section className={`${styles.sheet} ${styles['padding-025']}`}>
        {/* Main Table */}
        {/* sets repeatable report header and body area */}
        {/* set up as 24 column grid */}
        <table className={styles['sheet--main-table']}>
          {/* repeatable header */}
          {/* <thead> */}
            <tr className="v-align-top">
              {/* main content column */}
              <th colSpan="24">
                {/* logo/title */}
                <table>
                  <tbody>
                    <tr className="b-bot-1px">
                      {/* biz details */}
                      <td colSpan="20" className="text-left">
                        <p className="m-tb-0 p-b-5 fnt-title" style={{fontSize: '3rem'}}>
                          Small Group Session Notes
                        </p>
                      </td>
                      {/* logo */}
                      <td colSpan="4" className="text-right">
                        <img src={logoDarkImage} width="75" height="27" alt=""></img>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* session details */}
                <table className="m-t-15">
                  <tbody>
                    <tr>
                      {/* date */}
                      <td colSpan="6" className="b-bot-1px" style={{borderColor: 'black'}}>
                        <table style={{marginBottom: '25px'}}>
                          <tbody>
                            <tr>
                              <td className="text-left">Date:</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      {/* gutter */}
                      <td colSpan="1"></td>

                      {/* session */}
                      <td colSpan="6" className="b-bot-1px" style={{borderColor: 'black'}}>
                        <table style={{marginBottom: '25px'}}>
                          <tbody>
                            <tr>
                              <td className="text-left">Session:</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      {/* gutter */}
                      <td colSpan="1"></td>

                      {/* students */}
                      <td colSpan="20" className="b-bot-1px" style={{borderColor: 'black'}}>
                        <table style={{marginBottom: '25px'}}>
                          <tbody>
                            <tr>
                              <td className="text-left">Students:</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* end: session details */}
              </th>
            </tr>
          {/* </thead> */}
          {/* end: repeatable header */}

          {/* body */}
          <tbody>
            <tr className="v-align-top">
              {/* main content column */}
              <td colSpan="24">{steps.map(renderStep)}</td>
            </tr>
          </tbody>
          {/* end: body */}
        </table>
        {/* END: Main Table */}
      </section>
    </div>
  );
}
